import api from './api';
import { SPOP } from '../types';

const spopService = {
  // Get all SPOPs with pagination and search
  getSPOPs: (page = 1, limit = 10, search = '', isActive?: boolean, filters?: { spop_id?: string; [key: string]: any }) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      search
    });
    
    if (isActive !== undefined) {
      params.append('isActive', isActive.toString());
    }
    
    // Add additional filters
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString());
        }
      });
    }
    
    return api.get(`/spops?${params.toString()}`);
  },

  // Get SPOP by ID
  getSPOPById: (id: string) => api.get(`/spops/${id}`),

  // Get all SPOPs for dropdown (without pagination)
  getAllSPOPs: () => api.get('/spops?limit=1000'),

  // Create new SPOP
  createSPOP: (spopData: Omit<SPOP, 'id' | 'createdAt' | 'updatedAt'>) => 
    api.post('/spops', spopData),

  // Update SPOP
  updateSPOP: (id: string, spopData: Partial<Omit<SPOP, 'id' | 'createdAt' | 'updatedAt'>>) => 
    api.put(`/spops/${id}`, spopData),

  // Delete SPOP
  deleteSPOP: (id: string) => api.delete(`/spops/${id}`),

  // Get SPOPs near location
  getSPOPsNearLocation: (latitude: number, longitude: number, maxDistance = 5000) => {
    const params = new URLSearchParams({
      latitude: latitude.toString(),
      longitude: longitude.toString(),
      maxDistance: maxDistance.toString()
    });
    
    return api.get(`/spops/nearby?${params.toString()}`);
  },

  // Get SPOP statistics
  getSPOPStats: (filters?: { spop_id?: string; [key: string]: any }) => {
    const params = new URLSearchParams();
    
    // Add filters
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    return api.get(`/spops/stats${queryString ? `?${queryString}` : ''}`);
  }
};

export default spopService;
